import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { HalfCircleSpinner } from 'epic-spinners';

@Component({
    components: {
        HalfCircleSpinner
    }
})
export default class EpicSubmitButton extends Vue {
    public title: string = 'EpicSubmitButton';

    @Prop({ default: '100%' })
    public height: any;

    @Prop({ default: '100%' })
    public width: any;

    @Prop({ default: false })
    public loading: boolean = false;

    public loadingStyle = 'background-color: rgba(0, 154, 191, 0.4);';

    @Prop({ default: undefined })
    public data: any;

    @Watch('data', { immediate: true, deep: true })
    public onDataInput(val: any, oldVal: any) {
    }
}
